import { render, staticRenderFns } from "./MembershipFeePolicyDetail.vue?vue&type=template&id=5b765f5f&scoped=true&"
import script from "./MembershipFeePolicyDetail.vue?vue&type=script&lang=js&"
export * from "./MembershipFeePolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MembershipFeePolicyDetail.vue?vue&type=style&index=0&id=5b765f5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b765f5f",
  null
  
)

export default component.exports